import React from 'react';

import Button from '@atlaskit/button';
import QuestionCircleIcon from '@atlaskit/icon/glyph/question-circle';

const openDocumentationPage = () => {
  window.open('https://soldevelo.atlassian.net/l/cp/DR711qyK', '_blank');
};

export function OpenDocumentationButton(): JSX.Element {
  return (
    <Button
      onClick={openDocumentationPage}
      iconBefore={
        <QuestionCircleIcon
          label='Open documentation'
          primaryColor='var(--ds-icon, var(--ds-fb-icon))'
        />
      }
    />
  );
}
